import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'react-table';
import { Table } from '@components/Common';
import {
  getAmountColumn,
  getDirectionColumn,
  getEntryStateColumn,
  getShipmentTypeColumn,
  getUnloadingFinishedColumn,
} from '@components/Pages/Inventory/Common/entryColumns';
import { BookkeepingEntry } from '@api/queries/inventory';

interface Props {
  entries?: BookkeepingEntry[];
  billedEntryIds: Set<string>;
}

const BillingReportGrid: React.FC<Props> = ({ billedEntryIds, entries }) => {
  const { t } = useTranslation();

  const columns: Column[] = useMemo(
    () => [
      {
        Header: 'Id',
        id: 'id',
        accessor: 'id',
        show: false,
      },
      getEntryStateColumn(t),
      getAmountColumn(t),
      getDirectionColumn(t),
      getUnloadingFinishedColumn(t),
      getShipmentTypeColumn(t),
      {
        Header: t('reports.carrier_information'),
        id: 'carrierInformation',
        accessor: 'carrierInformation',
      },
      {
        Header: t('entry.isBilled'),
        id: 'isBilled',
        accessor: (entry: BookkeepingEntry) => {
          return billedEntryIds.has(entry.id) ? t('billing.billed') : t('billing.not_billed');
        },
      },
      {
        Header: t('entry.notes'),
        id: 'notes',
        accessor: 'notes',
      },
      {
        Header: t('entry.billing'),
        id: 'billingInformation',
        accessor: 'billingInformation',
      },
    ],
    [t, billedEntryIds]
  );

  return (
    <Table
      data={entries}
      columns={columns}
      filterable={false}
      defaultSortColumn="unloadingFinished"
      defaultSortDesc={true}
      defaultPageSize={20}
      noDataText={t('entry.no_rows_bookkeeping_reporting')}
    />
  );
};

export default BillingReportGrid;
